import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import * as fabric from 'fabric';

const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="2045" height="199" stroke="#000" stroke-linecap="round" stroke-linejoin="round" fill="#fff" fill-rule="evenodd" font-family="Roboto" font-size="14" text-anchor="middle">
<style><![CDATA[svg text{white-space:pre}]]></style><defs><style>@font-face{font-family:"Satisfy";src:url(data:application/font-woff;charset=utf-8;base64,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) format("woff"); font-weight:normal;font-style:normal;}</style></defs><text fill="#000" font-size="139.1027" font-family="Satisfy" stroke="none"><tspan x="1022.2031" y="130">To jest mój nowy długi tekst!!</tspan></text></svg>`;
const svg2 = new Image(150, 80);
svg2.crossOrigin = 'Anonymous';
console.log(svg2.src);
const heart = `<svg width="2048" height="2048" viewBox="0 0 2048 2048"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <path d="M1463.25 224.833C1268.917 224.833 1099.75 341 1024.083 509.167 948.417 341.167 779.25 224.833 584.917 224.833 319.583 224.833 103.75 440.833 103.75 706.167 103.75 1304.5 966.917 1797.167 1003.75 1817.833 1010.083 1821.333 1016.917 1823.167 1023.917 1823.167 1030.917 1823.167 1037.917 1821.333 1044.083 1817.833 1080.75 1797.167 1944.25 1304.5 1944.25 706.167 1944.417 440.833 1728.583 224.833 1463.25 224.833Z" style="fill:#DB4437;"/>
</svg>`;

@Component({
  selector: 'app-designer',
  templateUrl: './designer.component.html',
  styleUrls: ['./designer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DesignerComponent implements OnInit {
  @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLCanvasElement>;

  constructor() {}

  ngOnInit(): void {
    const canvas = new fabric.Canvas(this.canvas.nativeElement, {
      width: 1024,
      height: 1024,
    });

    const rect = new fabric.Circle({
      originX: 'left',
      originY: 'top',
      top: 150,
      left: 40,
      radius: 285,
      fill: 'red',
      stroke: 'green',
      strokeWidth: 10,
    });
    //d3mmhdibvwqnzq.cloudfront.net/assets/temas/b_6P3r/Bp5_d3/assets/463t1599214487730ce84f163d_l.png
    fabric.FabricImage.fromURL(
      '/assets/cover.png',
      { crossOrigin: 'anonymous' },
      { originX: 'left', originY: 'top' },
    ).then(function (oImg) {
      oImg.scale(0.22);

      const group = new fabric.Group([rect, oImg], {
        originX: 'left',
        originY: 'top',
        left: 150,
        top: 100,
      });
      canvas.add(group);
    });
    fabric.FabricImage.fromURL(
      'https://images.unsplash.com/photo-1660174154068-df8dab69ccc0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1200&q=80',
      { crossOrigin: 'anonymous' },
      { originX: 'left', originY: 'top' },
    ).then((image) => {
      // image.clipPath = new fabric.Circle({ originX: 'left', originY: 'top',
      //                                      radius:  100,
      //                                      originX: 'center',
      //                                      originY: 'center',
      //                                    });
      fabric
        .loadSVGFromString(heart)
        .then(({ objects: objects, options: options }) => {
          console.log(objects);
          const obj = fabric.util.groupSVGElements(
            objects.filter(
              (item): item is fabric.FabricObject => item !== null,
            ),
            {
              top: 700,
              left: 800,
            },
          );
          obj.originX = 'center';
          obj.originY = 'center';
          obj.set({
            top: 700,
            left: 700,
            width: 2048,
            height: 2048,
            strokeWidth: 15,
            stroke: '#FF0000',
          });
          obj.scale(0.5);

          const patternSourceCanvas = new fabric.StaticCanvas(null);
          image.objectCaching = true;
          console.log(image, patternSourceCanvas, obj);
          image.set({ strokeWidth: 0 });
          patternSourceCanvas.add(image);
          image.scaleToWidth(2048);
          patternSourceCanvas.setDimensions({
            width: image.getScaledWidth(),
            height: image.getScaledHeight(),
          });
          patternSourceCanvas.renderAll();
          obj.fill = new fabric.Pattern({
            // @ts-ignore
            source: patternSourceCanvas.getElement(),
            offsetY: -350,
            // offsetX: 0,
            repeat: `no-repeat`,
          });

          canvas.add(obj);
          canvas.requestRenderAll();
        });
    });
    fabric.FabricImage.fromURL(
      'https://images.unsplash.com/photo-1660174154068-df8dab69ccc0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=80',
      { crossOrigin: 'anonymous' },
      { originX: 'left', originY: 'top' },
    ).then(function (oImg) {
      oImg.set('strokeWidth', 15);
      oImg.set('stroke', 'rgba(125,0,0,1)');

      canvas.add(oImg);
    });
    fabric.util
      .loadImage(
        'https://images.unsplash.com/photo-1660174154068-df8dab69ccc0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=80',
        { crossOrigin: 'anonymous' },
      )
      .then((img) => {
        rect.set(
          'fill',
          new fabric.Pattern({
            // @ts-ignore
            source: img,
            offsetY: -160,
            repeat: `no-repeat`,
          }),
        );
        canvas.renderAll();
      });

    fabric.loadSVGFromString(svg).then(({ objects: res }) => {
      const obj = fabric.util.groupSVGElements(
        res.filter((item): item is fabric.FabricObject => item !== null),
      );
      // canvas.add(obj);
      canvas.renderAll();
    });
    svg2.addEventListener(
      'load',
      () => {
        const imgInstance = new fabric.FabricImage(svg2, {
          originX: 'left',
          originY: 'top',
          left: 300,
          top: 300,
          angle: 30,
          opacity: 1,
        });
        canvas.add(imgInstance);
        canvas.renderAll();
      },
      {
        once: true,
      },
    );
    svg2.src = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));

    document.querySelector('app-designer').appendChild(svg2);
  }
}
